/**
 * Ícone e cor de um grupo do chat Web.
 * O `icon` guardado é o NOME do ícone Lucide (mesmo padrão do IconPicker usado
 * em Tipos de Serviço, Motivos de Pausa etc.), então qualquer ícone vale.
 * As cores ficam num conjunto fechado — `accent` segue o tema do tenant.
 */
import * as LucideIcons from "lucide-react";
import { Users } from "lucide-react";

// Compatibilidade com os grupos criados antes do IconPicker (chaves curtas).
const LEGACY = {
  users: "Users",
  headphones: "Headphones",
  truck: "Truck",
  car: "Car",
  wrench: "Wrench",
  alert: "AlertTriangle",
  moon: "Moon",
  briefcase: "Briefcase",
};

export const GROUP_COLORS = {
  accent: { hex: null, label: "Padrão" },
  blue: { hex: "#2563EB", label: "Azul" },
  teal: { hex: "#0D9488", label: "Verde-água" },
  green: { hex: "#16A34A", label: "Verde" },
  amber: { hex: "#F59E0B", label: "Âmbar" },
  orange: { hex: "#FF9955", label: "Laranja" },
  red: { hex: "#DC2626", label: "Vermelho" },
  slate: { hex: "#475569", label: "Grafite" },
};

export const groupIcon = (name) => {
  const key = LEGACY[name] || name;
  return (key && LucideIcons[key]) || Users;
};

/** Cor do ícone e do fundo do badge — `accent` cai no tema do tenant. */
export const groupColors = (key) => {
  const hex = GROUP_COLORS[key]?.hex;
  return hex ? { fg: hex, bg: `${hex}1F` } : { fg: "var(--accent)", bg: "var(--accent-light)" };
};
